module.exports = __webpack_public_path__ + "static/media/map.6db9ba2e.png";